import React, { useState } from 'react';

const NativeSignIn = ({ onSignUp, callback, cancel }) => {
  const [formData, _setFormData] = useState({
    email: '',
    password: '',
  });
  const setFormData = (insert) => {
    _setFormData({ ...formData, ...insert });
  };

  return (
    <div
      style={{
        width: '100%',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <h2
        style={{
          marginBottom: 30,
          marginTop: 0,
        }}
      >
        Sign In
      </h2>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          marginBottom: '10px',
        }}
      >
        {/* Form */}
        <div>
          <div>
            <input
              type='email'
              placeholder='Email'
              value={formData.email}
              onChange={(e) => setFormData({ email: e.target.value })}
              style={{
                width: '100%',
                marginBottom: '10px',
                padding: '10px',
                border: '1px solid #436c9a',
                borderRadius: '5px',
              }}
            />
          </div>
          <div>
            <input
              type='password'
              placeholder='Password'
              value={formData.password}
              onChange={(e) => setFormData({ password: e.target.value })}
              style={{
                width: '100%',
                marginBottom: '10px',
                padding: '10px',
                border: '1px solid #436c9a',
                borderRadius: '5px',
              }}
            />
          </div>

          <div
            style={{
              height: 1,
              width: '100%',
              background: '#aaa',
              marginTop: 10,
              marginBottom: 20,
            }}
          ></div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <button
              disabled={!(formData.email && formData.password)}
              style={{
                background:
                  formData.email && formData.password ? '#436c9a' : 'grey',
                padding: 10,
                borderRadius: 10,
                border: 'none',
                width: '50%',
                color: '#fff',
                marginBottom: '10px',
              }}
              onClick={() => callback(formData)}
            >
              Sign In
            </button>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <button
            onClick={() =>
              window.open(
                'https://overwatch.ai/component/users/remind?Itemid=287',
                '_blank'
              )
            }
            style={{
              background: '#ed2028',
              padding: 10,
              borderRadius: 10,
              border: 'none',
              width: '50%',
              color: '#fff',
              marginBottom: '10px',
            }}
          >
            Forgot Username
          </button>
          <button
            onClick={() =>
              window.open(
                'https://overwatch.ai/component/users/reset?Itemid=287',
                '_blank'
              )
            }
            style={{
              background: '#ed2028',
              padding: 10,
              borderRadius: 10,
              border: 'none',
              width: '50%',
              color: '#fff',
              marginBottom: '10px',
            }}
          >
            Forgot Password
          </button>

          <div
            style={{
              height: 1,
              width: '100%',
              background: '#aaa',
              marginTop: 10,
              marginBottom: 20,
            }}
          ></div>

          <button
            onClick={onSignUp}
            style={{
              background: '#436c9a',
              padding: 10,
              borderRadius: 10,
              border: 'none',
              width: '50%',
              color: '#fff',
              marginBottom: '10px',
            }}
          >
            Create Account
          </button>
        </div>
      </div>
    </div>
  );
};

export default NativeSignIn;
